import { render, staticRenderFns } from "./CommissioningInspectionRejection.vue?vue&type=template&id=061db2ed&scoped=true"
import script from "./CommissioningInspectionRejection.vue?vue&type=script&lang=js"
export * from "./CommissioningInspectionRejection.vue?vue&type=script&lang=js"
import style0 from "./CommissioningInspectionRejection.vue?vue&type=style&index=0&id=061db2ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061db2ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VTextarea})
